// IMPORTS
// Assets
import BarGauge from './BarGauge';


// COMPONENT
export default function OverallUsage (props) {
   // Component
   return (
      <div className='oneport-dashboard-overallusage oneport-dashboard-bargraph'>
         <BarGauge onehive={props.onehive} title="Total Used Ports" current={props.parent.overallUsage.current} max={props.parent.overallUsage.max} />
      </div>
   );
}